import _ from 'lodash'

import { searchAPI } from '../../api'
import { searchUtils } from '../../utils'
import { types as filtersTypes } from './filters.module'


const DEFAULT_STATE = {
  activeTabIdx: 0,
  matches: {
    exact: [],
    close: [],
    matchesCount: null,
    relevantCount: null,
    totalCount: null,
    page: 1,
    isMoreToFetch: true,
    isFetching: false,
    isFetchingMore: false
  },
  filters: null,
  filtersOriginal: null
}

const PER_PAGE = 12

// Actions
export const types = {
  SET_ACTIVE_FILTER_TAB: 'gulftree/filtered-search/SET_ACTIVE_FILTER_TAB',
  SET_MATCHES: 'gulftree/filtered-search/SET_MATCHES',
  IS_FETCHING_MATCHES: 'gulftree/filtered-search/IS_FETCHING_MATCHES',
  IS_FETCHING_MORE_MATCHES: 'gulftree/filtered-search/IS_FETCHING_MORE_MATCHES',
  SET_FILTERS: 'gulftree/filtered-search/SET_FILTERS',
  RESET_ALL_FILTERS: 'gulftree/filtered-search/RESET_ALL_FILTERS',
  RESET_RESULTS: 'gulftree/filtered-search/RESET_RESULTS',
}

// Reducer
export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case types.SET_ACTIVE_FILTER_TAB:
      return {
        ...state,
        activeTabIdx: action.payload
      }

    case types.RESET_RESULTS:
      return {
        ...state,
        matches: {
          ...state.matches,
          exact: [],
          close: [],
          page: 1
        }
      }

    case types.SET_MATCHES:
      return {
        ...state,
        matches: {
          ...state.matches,
          exact: [...state.matches.exact, ...action.payload.results.exact],
          close: [...state.matches.close, ...action.payload.results.close],
          matchesCount: action.payload.result_count,
          relevantCount: action.payload.relevant_count,
          totalCount: action.payload.total_count,
          isMoreToFetch: (action.payload.results.exact.length + action.payload.results.close.length) >= PER_PAGE,
          page: state.matches.page + 1
        }
      }

    case types.IS_FETCHING_MATCHES:
      return {
        ...state,
        matches: {
          ...state.matches,
          isFetching: action.payload
        }
      }

    case types.IS_FETCHING_MORE_MATCHES:
      return {
        ...state,
        matches: {
          ...state.matches,
          isFetchingMore: action.payload
        }
      }

    case types.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
        filtersOriginal: action.payload
      }

    case types.RESET_ALL_FILTERS:
      return {
        ...state,
        filters: _.cloneDeep(state.filtersOriginal)
      }

    default:
      return state;
  }
}

// Action Creators
export function setActiveFilterTab(idx) {
  return {
    type: types.SET_ACTIVE_FILTER_TAB,
    payload: idx
  }
}

export function fetchMatches(fetchNextPage = false) {
  return (dispatch, getState) => {
    if (fetchNextPage) {
      dispatch({ type: types.IS_FETCHING_MORE_MATCHES, payload: true })
    } else {
      dispatch({ type: types.RESET_RESULTS })
      dispatch({ type: types.IS_FETCHING_MATCHES, payload: true })
    }

    const activeFilterIds = getState().filters.activeFilterIds
    const currentPage = fetchNextPage ? getState().filteredSearch.matches.page : 1

    searchAPI.getMatches(activeFilterIds, currentPage).then(res => {
      dispatch({ type: types.SET_MATCHES, payload: res })
      dispatch({ type: types.IS_FETCHING_MATCHES, payload: false })

      if (fetchNextPage) {
        dispatch({ type: types.IS_FETCHING_MORE_MATCHES, payload: false })
      }
    })
  }
}

export function fetchFilters() {
  return (dispatch, getState) => {
    searchAPI.getFilteredSearchFilters().then(res => {
      dispatch({ type: types.SET_FILTERS, payload: searchUtils.prepFilteredSearchFilters(res) })

      // Set blacklist filter IDs (IDs that are supposed to be ignored in search)
      const currentBlacklistIds = getState().filters.filterIdsBlacklist
      const newBlacklistIds = _.flatMap(res, filterGroup => {
        return _.flatMap(filterGroup, filter => {
          const termsToIgnore = filter.filter_terms.filter(term => _.get(term.meta, ['ignore']))
          return termsToIgnore.map(term => term.id)
        })
      })

      const ids = _.uniq([...currentBlacklistIds, ...newBlacklistIds])

      dispatch({ type: filtersTypes.UPDATE_ID_BLACKLIST, payload: ids })
    })
  }
}
